// Copyright 2016 Sorama B.V.

import { Color } from "services/Color/Color";
import { IColorMap } from "services/ColorMap/IColorMap";

export class JetColorMap implements IColorMap {
    public get name(): string {
        return "Jet";
    }

    public toColorRange(count: number): Color[] {
        const colors = <Color[]>[];

        for (let i = 0; i < count; i++) {
            const value = i / (count - 1);

            colors.push(new Color(this.red(value), this.green(value), this.blue(value), 1.0));
        }

        return colors;
    }

    public toColor(value: number): Color {
        return new Color(this.red(value), this.green(value), this.blue(value), 1.0);
    }

    private red(value: number): number {
        return Math.max(Math.min(Math.abs(value - 0.75) * -4.0 + 1.5, 1), 0);
    }

    private green(value: number): number {
        return Math.max(Math.min(Math.abs(value - 0.5) * -4.0 + 1.5, 1), 0);
    }

    private blue(value: number): number {
        return Math.max(Math.min(Math.abs(value - 0.25) * -4.0 + 1.5, 1), 0);
    }
}
